export default {"src":"/_next/static/media/friendship.239fcb9d.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};